import { AddIcon } from "../../../assets/icons";
import BlockHeader from "../../Common/BlockHeader/BlockHeader";
import CustomTooltip from "../../CustomTooltip";
import FormField from "../../FormField/FormField";
import UploadAllegato from "../UploadAllegato/UploadAllegato";
import { CrossIcon } from "../../../assets/icons";
import "./ScaffaliSection.scss";
import RipianiSection from "../RipianiSection/RipianiSection";
import CustomModal from "../../Common/CustomModal";
import { useState } from "react";



const ScaffaliSection = ({
  pianoId,
  pianoNome,
  scaffali,
  disabled = false,
  handleAddScaffale,
  handleRemoveScaffale,
  handleScaffaleAllegatoChange,
  handleUpdateRipiani,
  handleUpdateScaffaleNome,
}) => {


  const handleAllegatoChange = (val, id) => {
    handleScaffaleAllegatoChange(val, id, pianoId);
  };


  console.log("scaffali", scaffali);
  console.log("pianoId", pianoId);
  return (
    <div className="scaffali-section">
      <div className="scaffali-section-header">
        <p>
        {`Elenco degli scaffali ( ${scaffali.length} in totale) presenti nel piano ${pianoNome}`}
        </p>
        {!disabled && (
          <CustomTooltip text="Aggiungi Scaffali">
            <button
              className="repertori-button"
              onClick={() => handleAddScaffale(pianoId)}
            >
              <AddIcon fillColor="var(--archeo-color)" />
            </button>
          </CustomTooltip>
        )}
      </div>
      <div className="scaffali-section-container">
        {scaffali &&
          scaffali.map((scaffale, index) => (
            <div key={index} className="scaffali-container">
              {!disabled && (
                <button
                  className="scaffale-remove-icon"
                  onClick={() => handleRemoveScaffale(scaffale?.id, pianoId)}
                >
                  <CrossIcon width={20} height={20} />
                </button>
              )}
              <div className="scaffale-section-content">
                <FormField
                  fieldStructure={{
                    label: "Nome scaffale",
                    type: "text",
                    name: "name",
                    editable: true,
                  }}
                  disabled={disabled}
                  value={scaffale?.nome}
                  onChange={(val) => handleUpdateScaffaleNome(val, scaffale?.id, pianoId)}
                />
                {/*}
                <button onClick={() => setShowRipianiModal(true)}>
                  <p>Elenco ripiani</p>
                </button>
                */}
              </div>
              <RipianiSection ripiani={scaffale?.ripiani} setRipiani={(ripiani) => handleUpdateRipiani(ripiani, scaffale?.id, pianoId)} edit = {!disabled}/>
              <UploadAllegato
                id={scaffale?.id}
                disabled={disabled}
                allegato={scaffale?.allegato}
                onChange={handleAllegatoChange}
              />
            </div>
          ))}
        </div>
      </div>

  );
};

export default ScaffaliSection;
